import React from 'react';

import { dataLayerPushWrap } from '~/src/features/yandex-landing/utils';

import * as ST from './styled';

const RoutesBanner: React.FC = () => {
    const onHandleClick = () => {
        dataLayerPushWrap({ label: 'router' });
        const newWindow = window.open();
        if (newWindow) {
            newWindow.opener = null;
            newWindow.location.href = '/internet/equipment';
        }
    };

    return (
        <ST.ContainerRoutes>
            <ST.BannerWrapper>
                <ST.TextWrapper>
                    <ST.RouteTitle>
                        {'Яндекс.Станция + \nроутеры Дом.ру ='}&nbsp;
                    </ST.RouteTitle>
                    <ST.RouteSubtext>
                        Наши роутеры позаботятся, чтобы Яндекс.Станция стабильно работала в любом уголке квартиры
                    </ST.RouteSubtext>
                    <ST.RouteButton bType={'secondary'} onClick={onHandleClick}>
                        Выбрать роутер Дом.ру
                    </ST.RouteButton>
                </ST.TextWrapper>
            </ST.BannerWrapper>
        </ST.ContainerRoutes>
    );
};

export default RoutesBanner;
